import { Box, Body, List, Icon, ListItem, BoxProps } from '@hover/blueprint';
import React from 'react';
import { iCheckCircle } from '@hover/icons';

interface Props extends BoxProps {
  listItems: string[];
  body: string;
}

const AccordionContent: React.FC<Props> = ({ listItems, body, ...rest }) => (
  <Box px={0} flexDir="column" alignItems="flex-start" {...rest}>
    <Body size={500} mb={700}>
      {body}
    </Body>
    <List pl={0}>
      {listItems.map(item => (
        <ListItem key={item} d="flex" alignItems="center" mb={400}>
          <Icon
            m={0}
            mr={500}
            color="brandNavy.500"
            icon={iCheckCircle}
            size="default"
            minBlockSize="24px"
          />
          <Body flex={1} size={500} color="neutral.600" isSemiBold>
            {item}
          </Body>
        </ListItem>
      ))}
    </List>
  </Box>
);

export default AccordionContent;
